module.exports = __webpack_public_path__ + "img/jinjiang.14714f1f.png";